import { z } from 'zod';

import type { SelectMembersAndTeamsOption } from '#components/Approvals/components/RequestApprovalButton/SelectMembersAndTeams';

export const createApprovalFormSchema = ({ minNumApprovals }: { minNumApprovals: number }) =>
  z
    .object({
      // Both messages are spelled out so the copy on the reason field stays what it has always
      // been, instead of following Zod's own wording.
      reason: z
        .string({ error: (issue) => (issue.input === undefined ? 'Required' : undefined) })
        .min(1, 'String must contain at least 1 character(s)'),
      reviewers: z
        .array(
          // `z.custom` hands the predicate `unknown`, so each field is narrowed before it is read.
          z.custom<SelectMembersAndTeamsOption>(
            (val) =>
              val !== null &&
              typeof val === 'object' &&
              'kind' in val &&
              typeof val.kind === 'string' &&
              ['member', 'team'].includes(val.kind) &&
              'value' in val &&
              typeof val.value === 'string',
          ),
        )
        .min(minNumApprovals, 'Reviewers are required'),
    })
    .passthrough();

export const commentFormSchema = z
  .object({
    comment: z.string().optional(),
  })
  .passthrough();

export type ApprovalFormSchema = z.infer<ReturnType<typeof createApprovalFormSchema>>;
export type CommentFormSchema = z.infer<typeof commentFormSchema>;
